import { isNil } from 'lodash-es'

/**
 * Calculates the client demand for a shift.
 * Client demand is the number of workers required minus both the reported demand buffer
 * and the agency reported demand buffer.
 * If both buffers are null or undefined, returns null.
 */
export const calculateClientDemand = (shift: {
  workers_required?: number
  reported_demand_buffer?: number | null
  agency_reported_demand_buffer?: number | null
}): number | null => {
  const workersRequired = shift.workers_required || 0
  const reportedDemandBuffer = shift.reported_demand_buffer
  const agencyReportedDemandBuffer = shift.agency_reported_demand_buffer

  // If both buffers are null/undefined, return null
  if (isNil(reportedDemandBuffer) && isNil(agencyReportedDemandBuffer)) {
    return null
  }

  // Treat null buffers as 0 when at least one buffer is present
  const flexBuffer = reportedDemandBuffer ?? 0
  const agencyBuffer = agencyReportedDemandBuffer ?? 0

  return workersRequired - flexBuffer - agencyBuffer
}
